import { ReactNode } from "react"
import { PostHogConfig } from "posthog-js"
import { PostHogProvider } from "posthog-js/react"

import { POSTHOG_HOST, POSTHOG_KEY } from "#/shared/constants"
import { useZarazAnalyticsConsent } from "#/shared/hooks"

type MezoPosthogProviderProps = {
  children: ReactNode
}

export default function MezoPosthogProvider({
  children,
}: MezoPosthogProviderProps) {
  const { hasConsent } = useZarazAnalyticsConsent()

  const options: Partial<PostHogConfig> = {
    api_host: POSTHOG_HOST,
    // Feature flag from Posthog values are calculated based on a user's
    // properties. By setting person_profiles to always, we ensure that all users
    // are identified. This is only relevant if our feature flag is shown to both
    // logged out AND logged in users.
    persistence: hasConsent ? "localStorage+cookie" : "memory",
    person_profiles: hasConsent ? "always" : "identified_only",
  }

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  )
}
